class moreLessText extends HTMLElement {
  constructor() {
    super();
    this.initializeFunction = this.initializeFunction.bind(this);
  }

  connectedCallback() {
    this.initializeFunction();
  }

  initializeFunction() {
    const moreButton = this.querySelector('.more');
    const lessButton = this.querySelector('.less');
    const descriptionElement = this.querySelector('[moreLessText]');

    let descriptionText = descriptionElement.querySelector('.clp-desc');
    let lineHeight = parseFloat(getComputedStyle(descriptionText).lineHeight);
    let twoLinesHeight = lineHeight * 2;

    if (!descriptionElement || !moreButton || !lessButton) return;

    const checkHight = () => {
      descriptionText = descriptionElement.querySelector('p') || descriptionElement.querySelector('.clp-desc');

      lineHeight = parseFloat(getComputedStyle(descriptionText).lineHeight);
      twoLinesHeight = lineHeight * 2;

      if (descriptionText.scrollHeight - 1 <= twoLinesHeight) {
        moreButton.style.display = 'none';
        lessButton.style.display = 'none';
      } else {
        moreButton.style.display = 'block';
        updateText(false);
      }
    };

    const updateText = (showFullText) => {
      descriptionElement.classList.toggle('active', showFullText);
      moreButton.style.display = showFullText ? 'none' : 'block';
      lessButton.style.display = showFullText ? 'block' : 'none';
    };

    const handleKeyPress = (event, button) => {
      if (event.key === 'Enter' || event.key === ' ') {
        event.preventDefault();
        button.click();
      }
    };

    moreButton.addEventListener('click', () => {
      updateText(true);
    });

    lessButton.addEventListener('click', () => {
      updateText(false);
    });

    moreButton.addEventListener('keydown', (e) => handleKeyPress(e, moreButton));
    lessButton.addEventListener('keydown', (e) => handleKeyPress(e, lessButton));

    window.addEventListener('resize', () => {
      checkHight();
    });

    window.addEventListener('DOMContentLoaded', () => {
      checkHight();
    });

    updateText(false);
  }
}

const init = () => {
  if (!customElements.get('more-less')) {
    customElements.define('more-less', moreLessText);
  }
};

init();
